export const environment = {
  production: false,
  apiUrl: 'https://dev-api-business.click-market.ru',
  marketUrl: 'https://admin.click-market.ru',
  wsUrl: 'https://dev-api-business.click-market.ru/wsMessenger',
  recaptchaSiteKey: '6LcbfPoqAAAAAMo09chxp5FjEnIPRicOaGxgWQtZ',
  yandexMapKey: 'd30beba5-a507-4e6b-9d7b-48c0354d06c0',
  socials: {
    telegram: '',
    vk: '',
  },
};
